import { PROTECTION_SERVICES_EXPERIAN_FORM }  from "../constants";

const initialState = {}

const getProtectionServicesExperianReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case PROTECTION_SERVICES_EXPERIAN_FORM.GET_PROTECTION_SERVICES_EXPERIAN_DETAILS:
            return {
                ...state,
                ...payload
            }
        case PROTECTION_SERVICES_EXPERIAN_FORM.GET_PROTECTION_SERVICES_EXPERIAN_DETAILS_CHECK_MY_REQUESTS:
            return {
                ...state,
                ...payload
            }
        case PROTECTION_SERVICES_EXPERIAN_FORM.GET_PROTECTION_SERVICES_EXPERIAN_SUCCESS:
            return {
                ...payload
            }
        case PROTECTION_SERVICES_EXPERIAN_FORM.GET_PROTECTION_SERVICES_EXPERIAN_FAIL:
            return {
                ...payload
            }
        case PROTECTION_SERVICES_EXPERIAN_FORM.CLEAR_DETAILS:
            return {
                ...payload
            }
        default:
            return state;
    }
}

export default getProtectionServicesExperianReducer;
